import { useState, useEffect } from "react";
import { BiWifi, BiWifi1, BiWifi2 } from "react-icons/bi";

type WifiConnectingIconProps = {
  style?: React.CSSProperties | undefined;
  className?: string | "";
};

/**
 * 连接中的Wifi图标
 */
function WifiConnectingIcon(props: WifiConnectingIconProps) {
  const [index, setIndex] = useState(0);

  const icons = [BiWifi1, BiWifi2, BiWifi];

  useEffect(() => {
    const time = setTimeout(() => {
      if (index >= icons.length - 1) {
        setIndex(0);
        return;
      }
      setIndex((data) => data + 1);
    }, 1000);

    return () => {
      clearInterval(time);
    };
  }, [index]);

  const Icon = icons[index];

  return (
    <Icon
      style={{
        ...(props.style || {}),
      }}
      className={props.className || ""}

    />
  );
}
export default WifiConnectingIcon;
